import {
    CreditCard,
    FileText,
    Headphones,
    Settings,
    Shapes,
    ShieldCheck,
    Sparkles,
    Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

// AIDEV-NOTE: Single source of truth for help center categories.
// Used by the frontend (sidebar, landing page) AND keystatic.config.ts (editor select options).
// To add a category: add one entry here — no other files need to change.
export interface CategoryConfig {
    value: string;
    label: string;
    icon: LucideIcon;
    description: string;
}

export const HELP_CATEGORIES: CategoryConfig[] = [
    {
        value: "getting-started",
        label: "Getting Started",
        icon: Sparkles,
        description: "Set up your account and learn the basics",
    },
    {
        value: "sessions",
        label: "Sessions",
        icon: FileText,
        description: "Understand session notes, transcripts, and stories",
    },
    {
        value: "parts",
        label: "Parts",
        icon: Shapes,
        description: "View and explore parts discovered in your sessions",
    },
    {
        value: "meditations",
        label: "Meditations",
        icon: Headphones,
        description: "Access guided meditations tailored to your journey",
    },
    {
        value: "for-practitioners",
        label: "For Practitioners",
        icon: Users,
        description: "Manage clients, sessions, and clinical tools",
    },
    {
        value: "billing",
        label: "Billing & Membership",
        icon: CreditCard,
        description:
            "Understand your plan, manage your subscription, and get billing answers",
    },
    {
        value: "privacy-security",
        label: "Privacy & Security",
        icon: ShieldCheck,
        description:
            "Where your data lives, who can see it, and how to delete it",
    },
    {
        value: "account",
        label: "Account & Settings",
        icon: Settings,
        description: "Manage your account, preferences, and privacy",
    },
];

export const CATEGORY_MAP = Object.fromEntries(
    HELP_CATEGORIES.map((c) => [c.value, c]),
) as Record<string, CategoryConfig>;
